
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SessionDialog extends SiteEntityDialog<SessionRow, any> {
        protected getFormKey() { return SessionForm.formKey; }
        protected getIdProperty() { return SessionRow.idProperty; }
        protected getLocalTextPrefix() { return SessionRow.localTextPrefix; }
        protected getNameProperty() { return SessionRow.nameProperty; }
        protected getService() { return SessionService.baseUrl; }

        protected form = new SessionForm(this.idPrefix);

        protected updateInterface() {
            super.updateInterface();

            this.cloneButton.hide();
        }

    }
}